import React from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import Dialog from '@mui/material/Dialog';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import { TransitionProps } from '@mui/material/transitions';
import DialogTitle from '@mui/material/DialogTitle';
import Logo from 'components/Helpers/Logo';

interface FormDialogProps {
  children?: React.ReactNode;
  onClose: () => void;
  preview?: boolean;
}

const useStyles = makeStyles(
  (theme: Theme) => ({
    container: {},
    paper: {
      backgroundColor: 'black',
    },
    preview: {
      backgroundColor: 'rgba(0,0,0,0.9)',
    },
    appBar: {
      backgroundColor: '#000',
      backgroundImage: 'none',
      boxShadow: '0px 9px 40px rgba(0, 0, 0, 0.16)',
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    toolbar: {
      minHeight: 60,
    },
    menuButton: {},
  }),
  { name: 'FormDialog' },
);

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FormDialog: React.FC<FormDialogProps> = ({ onClose, children, preview = false }) => {
  const classes = useStyles();
  return (
    <Dialog classes={{ paper: preview ? classes.preview : classes.paper }} fullScreen open onClose={onClose} TransitionComponent={Transition}>
      <DialogTitle sx={{ p: 0 }}>
        <Toolbar className={classes.toolbar}>
          <Logo />
          <Box sx={{ flexGrow: 1 }} />
          <IconButton edge="end" className={classes.menuButton} color="primary" onClick={onClose} aria-label="close" size="large">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </DialogTitle>
      {children}
    </Dialog>
  );
};

export default FormDialog;
